import { getData } from '@core/utils/http/general'
import store from '@/store'

const useLayoutHorizontal = async id => {
  try {
    const token = store.state?.cuenta?.session?.token

    if (!token) return false

    const response = await getData(
      {
        action: 15,
        token,
        rolSelected: id,
      },
      'wsadminpagecampus',
    )

    if (response?.status === 200 && response?.data?.status === 200) {
      return response.data.p === true
    }

    return false
  } catch (error) {
    return false
  }
}

export default useLayoutHorizontal
